import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestfulApiService } from '../restful-api.service';
import {
  UserAssetsPayload,
  UserAssetsResponse,
  ProjectUserAssetsResponse,
  OrganisationFiltersResponse,
  ProjectFiltersResponse,
} from '../../models/user-assets.model';
import { DynamicTranslationService } from '../dynamic-translation.service';

@Injectable({
  providedIn: 'root',
})
export class UserAssetsService {
  private readonly endpoint = '/v1/user-assets';

  constructor(
    private restfulApiService: RestfulApiService,
    private translationService: DynamicTranslationService,
  ) {}

  /**
   * Get user assets with filter and pagination.
   * The languageCode in the payload is always overridden with the current
   * 3-character language code from the language switcher.
   */
  getUserAssets(payload: UserAssetsPayload): Observable<UserAssetsResponse | ProjectUserAssetsResponse> {
    return this.restfulApiService.post(
      this.endpoint,
      { ...payload, languageCode: this.translationService.getIso639Code() }
    ) as Observable<UserAssetsResponse | ProjectUserAssetsResponse>;
  }

  /**
   * Get organization filter options.
   * Language code is taken from the current language switcher selection.
   */
  getOrganisationFilters(): Observable<OrganisationFiltersResponse> {
    const languageCode = this.translationService.getIso639Code();
    return this.restfulApiService.get(
      `${this.endpoint}/filters/ORGANISATION?languageCode=${languageCode}`
    ) as Observable<OrganisationFiltersResponse>;
  }

  /**
   * Get project filter options.
   * Language code is taken from the current language switcher selection.
   */
  getProjectFilters(): Observable<ProjectFiltersResponse> {
    const languageCode = this.translationService.getIso639Code();
    return this.restfulApiService.get(
      `${this.endpoint}/filters/PROJECT?languageCode=${languageCode}`
    ) as Observable<ProjectFiltersResponse>;
  }
}
